// Packages and components
import styled from 'styled-components';
import { Box, Layer } from 'grommet';

// Helpers and utilities
import { pxToRem } from '@theme/utils/sizing';

// Constants
const controlHeight = 72;
const trayControlHeight = pxToRem(controlHeight);

const trayBorderRadius = 16;

// Styled components

export const Tray: typeof Layer = styled(Layer)`
  border-top-left-radius: ${pxToRem(trayBorderRadius)};
  border-top-right-radius: ${pxToRem(trayBorderRadius)};
  min-height: ${pxToRem(controlHeight * 2)};
  max-width: ${pxToRem(512)};
  overflow: hidden;
  width: 100%;
  &.is-large,
  &.is-xlarge {
    border-radius: ${pxToRem(trayBorderRadius * 2)};
  }
`;

export const TrayContainer: typeof Box = styled(Box)`
  max-height: none;
  padding: 0;
  position: relative;

  /** Large/XLarge */
  &.is-large,
  &.is-xlarge {
    max-height: ${pxToRem(800)};
    min-height: initial;
  }
`;

export const TrayControls: typeof Box = styled(Box)`
  background: white;
  height: ${trayControlHeight};
  position: fixed;
  width: 100%;
  z-index: 2;
  &.is-transparent-controls {
    background: transparent;
    z-index: 1;
  }
`;

interface TrayBodyProps {
  inlineClose?: boolean;
}

export const TrayBody = styled(Box)<TrayBodyProps>`
  position: relative;
  z-index: 1;
  margin-top: ${({ inlineClose }) =>
    inlineClose ? '0' : `calc(${trayControlHeight} - ${pxToRem(27)})`};
  padding-top: ${({ inlineClose }) => (inlineClose ? '0' : undefined)};
`;
